import axios from 'axios'
import { AuthModel, UserModel } from './_models'

export const GET_USER_BY_ACCESSTOKEN_URL = `${process.env.REACT_APP_API_URL}/auth/verify_token`
export const LOGIN_URL = `${process.env.REACT_APP_API_URL}/auth/login`
export const REGISTER_URL = `${process.env.REACT_APP_API_URL}/auth/egister`
export const REQUEST_PASSWORD_URL = `${process.env.REACT_APP_API_URL}/forgot_password`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    firstname: firstname,
    lastname: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    accessToken: token,
  })
}
